import React, { Fragment } from 'react';
import { AddNonStdAccessory } from './add_non_std_accessory';
import { SelectedNonStdAccessoryList } from './selected_non_std_accessory_list';

/**
 * Renders the NonStandardAccessories component
 * @return {Node} Returns the NonStandardAccessories component
 */
const NonStandardAccessories = () => (
    <>
        <AddNonStdAccessory />
        <SelectedNonStdAccessoryList />
    </>
);

export { NonStandardAccessories };
